import { useSetAtom } from 'jotai';
import { useSidePanel } from '../side-panel-provider';
export const useDispatch = () => {
  const {
    dispatchAtom
  } = useSidePanel();
  const dispatch = useSetAtom(dispatchAtom);
  return dispatch;
};